/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { features, dateStyle, language } from "config";
import { FirebaseContext } from "common";

export default function Users() {
  const { api } = useContext(FirebaseContext);
  const { addUser, editUser, deleteUser, checkUserExists } = api;
  const [data, setData] = useState([]);
  const [practices, setPractices] = useState({});
  const usersdata = useSelector((state) => state.doctors);
  const practicetypes = useSelector((state) => state.practicetypes);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("i am the auth", auth);
    console.log("i am the docotrs", usersdata.users);
    if (usersdata.users.userType === "doctor") {
      setData(usersdata.users.filter((user) => user.userType === "doctor"));
    } else {
      setData(usersdata.users);
    }
  }, [usersdata.users]);

  useEffect(() => {
    if (practicetypes.practices) {
      let obj = {};
      practicetypes.practices.map(
        (practice) => (obj[practice.name] = practice.name)
      );
      setPractices(obj);
    }
  }, [practicetypes.practices]);

  const columns = [
    {
      title: language.createdAt,
      field: "createdAt",
      editable: "never",
      defaultSort: "desc",
      render: (rowData) =>
        rowData.createdAt
          ? new Date(rowData.createdAt).toLocaleString(dateStyle)
          : null,
    },
    { title: language.first_name, field: "firstName", initialEditValue: "" },
    { title: language.last_name, field: "lastName", initialEditValue: "" },
    {
      title: language.email,
      field: "email",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo",
    },
    {
      title: language.mobile,
      field: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo",
    },
    {
      title: language.profile_image,
      field: "profile_image",
      render: (rowData) =>
        rowData.profile_image ? (
          <img
            alt="Profile"
            src={rowData.profile_image}
            style={{ width: 50, borderRadius: "50%" }}
          />
        ) : null,
      editable: "never",
    },
    {
      title: language.vehicle_model_name,
      field: "vehicleMake",
      initialEditValue: "",
    },
    {
      title: language.vehicle_model_no,
      field: "vehicleModel",
      initialEditValue: "",
    },
    {
      title: language.vehicle_reg_no,
      field: "vehicleNumber",
      initialEditValue: "",
    },
    { title: language.other_info, field: "other_info", initialEditValue: "" },
    { title: language.practice_type, field: "practiceType", lookup: practices },
    {
      title: language.account_approve,
      field: "approved",
      type: "boolean",
      initialEditValue: true,
    },
    {
      title: language.doctor_active,
      field: "doctorActiveStatus",
      type: "boolean",
      initialEditValue: true,
    },
    {
      title: language.lisence_image,
      field: "licenseImage",
      render: (rowData) =>
        rowData.licenseImage ? (
          <img
            alt="License"
            src={rowData.licenseImage}
            style={{ width: 100 }}
          />
        ) : null,
      editable: "never",
    },
    {
      title: language.wallet_balance,
      field: "walletBalance",
      type: "numeric",
      editable: "never",
      initialEditValue: 0,
    },
    {
      title: language.signup_via_referral,
      field: "signupViaReferral",
      editable: "never",
    },
    {
      title: language.referralId,
      field: "referralId",
      editable: "never",
      initialEditValue: "",
    },
    { title: language.bankName, field: "bankName", initialEditValue: "" },
    { title: language.bankCode, field: "bankCode", initialEditValue: "" },
    { title: language.bankAccount, field: "bankAccount", initialEditValue: "" },
    { title: language.bankType, field: "bankType", initialEditValue: "" },
    {
      title: language.queue,
      field: "queue",
      type: "boolean",
      initialEditValue: false,
    },
  ];

  return usersdata.loading ? (
    <CircularLoading />
  ) : (
    <MaterialTable
      title={language.doctors}
      columns={columns}
      data={data}
      options={{
        exportButton: true,
        sorting: true,
      }}
      editable={{
        onRowAdd: (newData) =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              checkUserExists(newData).then((res) => {
                if (res.users && res.users.length > 0) {
                  alert(language.user_exists);
                  reject();
                } else if (res.error) {
                  alert(language.email_or_mobile_issue);
                  reject();
                } else {
                  newData["createdByAdmin"] = true;
                  newData["userType"] = "doctor";
                  newData["createdAt"] = new Date().toISOString();
                  newData["referralId"] =
                    newData.firstName.toLowerCase() +
                    Math.floor(1000 + Math.random() * 9000).toString();
                  let role = auth.info.profile.userType;
                  if (role === "admin") {
                    newData["admin"] = auth.info.uid;
                  }
                  dispatch(addUser(newData));
                  resolve();
                }
              });
            }, 600);
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              dispatch(editUser(oldData.id, newData));
            }, 600);
          }),
        onRowDelete: (oldData) =>
          features.AllowCriticalEditsAdmin
            ? new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  dispatch(deleteUser(oldData.id));
                }, 600);
              })
            : new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  alert(language.demo_mode);
                }, 600);
              }),
      }}
    />
  );
}
